/** @jsx jsx */
import { jsx, ThemeProvider as BaseThemeProvider } from 'theme-ui';
import { defaultTheme } from '../theme';
export var ThemeProvider = function (_a) {
    var children = _a.children;
    return jsx(BaseThemeProvider, { theme: defaultTheme }, children);
};
//# sourceMappingURL=ThemeProvider.js.map